import { getIsMobile } from "../../helpers/getIsMobile";

const DEVICE_OFFSETS = {
    TIP_OFFSET: {
        mobile: 4,
        desktop: 16,
    },
    VIEWPORT_PADDING: {
        mobile: 4,
        desktop: 8,
    },
};

const getResponsiveValue = (configKey) => {
    const device = getIsMobile() ? "mobile" : "desktop";
    return DEVICE_OFFSETS[configKey][device];
};

export const UI_OFFSETS = Object.keys(DEVICE_OFFSETS).reduce((acc, key) => {
    Object.defineProperty(acc, key, {
        get: () => getResponsiveValue(key),
        enumerable: true,
    });
    return acc;
}, {});
